module.exports = __webpack_public_path__ + "assets/img/use-scene-2.75b41946.png";